import { createAsyncThunk } from "@reduxjs/toolkit";
import { getApi, postApi } from "../../../services/apiServices";
import {
  ORDER_REFRESH_API,
  SUBORDER_REFRESH_API,
} from "../../constants/apiConstants";
import Alertify from "../../../services/alertify";

export const RefreshOrderItemsAPI = createAsyncThunk(
  "orders/refresh",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getApi(ORDER_REFRESH_API);
      // console.log(response,"order")
      return response;
    } catch (error) {
      console.error("Error fetching Sub Order Items:", error);
      Alertify.error(
        error.response?.data?.message || "Failed to refresh order items."
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const RefreshSubOrderItemsAPI = createAsyncThunk(
  "orders/refresh",
  async (reqData, { rejectWithValue }) => {
    try {
      const response = await postApi(SUBORDER_REFRESH_API, reqData);
      //   console.log(response, "sub order");
      return response;
    } catch (error) {
      console.error("Error fetching Sub Order Items:", error);
      Alertify.error(
        error.response?.data?.message || "Failed to refresh order items."
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
